var shiyu = [
    {
        "skillName": "翎击",
        "skillProperty": [
            "法术攻击",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_d481cadb-224f-4436-a395-828f916efd8c_2110",
        "skillDescribe": {
            "main": "对前方扇形区域的敌方造成伤害，并有一定概率附加羽落效果",
            "static": [
                "造成法术伤害，最后一击可造成双倍伤害"
            ],
            "addition": [],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能伤害提高4%"
                            },
                            {
                                "layer": 4,
                                "value": "技能伤害提高8%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能对“羽落”状态下的目标额外造成2%*“羽落”层数的伤害"
                            },
                            {
                                "layer": 9,
                                "value": "本技能对“羽落”状态下的目标额外造成4%*“羽落”层数的伤害"
                            },
                            {
                                "layer": 10,
                                "value": "本技能对“羽落”状态下的目标额外造成6%*“羽落”层数的伤害"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "技能造成的“羽落”状态最多可叠加4层"
                            },
                            {
                                "layer": 14,
                                "value": "技能造成的“羽落”状态最多可叠加5层"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成伤害额外提高7.5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成伤害额外提高15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 5,
                                "value": "“羽落”状态的持续时间提高1秒"
                            },
                            {
                                "layer": 6,
                                "value": "“羽落”状态的持续时间提高2秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "每次命中敌方扣除敌人2点轻功值"
                            },
                            {
                                "layer": 4,
                                "value": "每次命中敌方扣除敌人4点轻功值"
                            },
                            {
                                "layer": 5,
                                "value": "每次命中敌方扣除敌人6点轻功值"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "每次命中敌方，使敌人降低3%的躲闪率"
                            },
                            {
                                "layer": 9,
                                "value": "每次命中敌方，使敌人降低6%的躲闪率"
                            },
                            {
                                "layer": 10,
                                "value": "每次命中敌方，使敌人降低9%的躲闪率"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能每次命中敌人，有5%的概率使“华绽天羽”技能的冷却时间降低1秒"
                            },
                            {
                                "layer": 14,
                                "value": "本技能每次命中敌人，有10%的概率使“华绽天羽”技能的冷却时间降低1秒"
                            },
                            {
                                "layer": 15,
                                "value": "本技能每次命中敌人，有15%的概率使“华绽天羽”技能的冷却时间降低1秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "天狩光轮",
        "skillProperty": [
            "魔法攻击",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_4bf964e5-fff1-4ab8-bb6a-ecf6c7a1c3db_2114",
        "skillDescribe": {
            "main": "向目标扔出一颗光球，光球触碰到敌方会对产生爆炸，对周围敌方造成伤害",
            "static": [
                "光球爆炸后对周围所有敌方造成法术伤害"
            ],
            "addition": [
                {
                    "initiative": "为敌人附加<font color='#66CD00'>羽落</font>状态，最多可叠加3层"
                }
            ],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能伤害提高5%"
                            },
                            {
                                "layer": 4,
                                "value": "技能伤害提高10%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能对“羽落”状态下的目标额外造成2%*“羽落”层数的伤害"
                            },
                            {
                                "layer": 9,
                                "value": "本技能对“羽落”状态下的目标额外造成4%*“羽落”层数的伤害"
                            },
                            {
                                "layer": 10,
                                "value": "本技能对“羽落”状态下的目标额外造成6%*“羽落”层数的伤害"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "光球爆炸时命中人数少于3人，额外造成10%的伤害"
                            },
                            {
                                "layer": 14,
                                "value": "光球爆炸时命中人数少于3人，额外造成20%的伤害"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成伤害额外提高7.5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成伤害额外提高15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            },
                            {
                                "layer": 10,
                                "value": "技能冷却时间降低20%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "光球的移动速度提高50%"
                            },
                            {
                                "layer": 4,
                                "value": "光球的移动速度提高100%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能命中敌方后，对敌人造成“偏斜”效果，命中率下降10%"
                            },
                            {
                                "layer": 9,
                                "value": "本技能命中敌方后，对敌人造成“偏斜”效果，命中率下降20%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能命中敌方后，使敌人攻击力下降3%（可以被驱散），持续2秒"
                            },
                            {
                                "layer": 14,
                                "value": "本技能命中敌方后，使敌人攻击力下降6%（可以被驱散），持续2秒"
                            },
                            {
                                "layer": 15,
                                "value": "本技能命中敌方后，使敌人攻击力下降10%（可以被驱散），持续2秒"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能命中“羽落”状态下的目标时，有40%概率使敌人定身1秒"
                            },
                            {
                                "layer": 14,
                                "value": "本技能命中“羽落”状态下的目标时，有100%概率使敌人定身1秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ]
            ]
        }
    },
    {
        "skillName": "破冥",
        "skillProperty": [
            "法术攻击",
            "引导技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_0e76ab26-1699-44b9-8d69-28d3d16b0de1_2115",
        "skillDescribe": {
            "main": "持续对前方敌人造成伤害",
            "static": [
                "2秒内每0.5秒对敌方造成造成法术伤害，最后一次结算使自身获得一层羽辉状态"
            ],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能造成的所有伤害提升5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能造成的所有伤害提升10%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能对眩晕状态敌人造成伤害提高17%"
                            },
                            {
                                "layer": 9,
                                "value": "本技能对眩晕状态敌人造成伤害提高34%"
                            },
                            {
                                "layer": 10,
                                "value": "本技能对眩晕状态敌人造成伤害提高51%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "技能对生命值低于上限50%的敌人造成的法术伤害额外提高23%"
                            },
                            {
                                "layer": 14,
                                "value": "技能对生命值低于上限50%的敌人造成的法术伤害额外提高45%"
                            },
                            {
                                "layer": 15,
                                "value": "技能对生命值低于上限50%的敌人造成的法术伤害额外提高67%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成的伤害额外提高7.5%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成的伤害额外提高15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "破冥结算间隔变为0.25秒一次，持续时间降为1秒（习得高级破冥卷二·羽后失效）"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "破冥可以在移动过程中释放"
                            },
                            {
                                "layer": 4,
                                "value": "破冥可以在移动过程中释放且在破冥释放期间，自身移动速度提高50%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "破冥释放期间，自身物理防御力和法术防御力提升3%"
                            },
                            {
                                "layer": 9,
                                "value": "破冥释放期间，自身物理防御力和法术防御力提升6%"
                            },
                            {
                                "layer": 10,
                                "value": "破冥释放期间，自身物理防御力和法术防御力提升9%"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 3,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "破冥释放期间，受到的伤害降低6%"
                            },
                            {
                                "layer": 14,
                                "value": "破冥释放期间，受到的伤害降低12%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 6,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "破冥每次命中“羽落”状态下的目标时，有10%概率使敌人眩晕2秒"
                            },
                            {
                                "layer": 9,
                                "value": "破冥每次命中“羽落”状态下的目标时，有20%概率使敌人眩晕2秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 3,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "破冥的持续时间增加1秒"
                            },
                            {
                                "layer": 14,
                                "value": "破冥的持续时间增加2秒"
                            },
                            {
                                "layer": 15,
                                "value": "破冥的持续时间增加3秒"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 6,
                            "line": "69"
                        }
                    }
                ]
            ]
        }
    },
    {
        "skillName": "锁厄",
        "skillProperty": [
            "法术技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_9b02c274-c27b-437e-a34f-6dc8ecdbcc09_2116",
        "skillDescribe": {
            "main": "将前方扇形区域的敌方拉至身前并造成伤害和控制效果",
            "static": [
                "造成的法术伤害，拉至身边并造成眩晕效果"
            ],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能伤害提高9%"
                            },
                            {
                                "layer": 4,
                                "value": "技能伤害提高18%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能对“羽落”状态下的目标额外造成2%*“羽落”层数的伤害"
                            },
                            {
                                "layer": 9,
                                "value": "本技能对“羽落”状态下的目标额外造成4%*“羽落”层数的伤害"
                            },
                            {
                                "layer": 10,
                                "value": "本技能对“羽落”状态下的目标额外造成6%*“羽落”层数的伤害"
                            }
                        ],
                        "require": {
                            "preNum": 2,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "使敌人获得易伤效果（不可被驱散），受到伤害提高5%，持续3秒"
                            },
                            {
                                "layer": 14,
                                "value": "使敌人获得易伤效果（不可被驱散），受到伤害提高10%，持续3秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成伤害额外提高14%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成伤害额外提高28%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 4,
                                "value": "技能冷却时间降低14%"
                            },
                            {
                                "layer": 5,
                                "value": "技能冷却时间降低20%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能造成“眩晕”效果的持续时间提高0.5秒"
                            },
                            {
                                "layer": 4,
                                "value": "本技能造成“眩晕”效果的持续时间提高1秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能命中会降低敌人10点轻功值"
                            },
                            {
                                "layer": 9,
                                "value": "技能命中会降低敌人20点轻功值"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 2,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能的控制等级提高10"
                            },
                            {
                                "layer": 14,
                                "value": "本技能的控制等级提高20"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "50%的概率驱散对方1个（1层）正面状态"
                            },
                            {
                                "layer": 9,
                                "value": "100%的概率驱散对方1个（1层）正面状态"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 2,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能成功驱散目标状态后，增加自身800×驱散状态层数的物理/法术防御力，持续5秒"
                            },
                            {},
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ]
            ]
        }
    },
    {
        "skillName": "鸿裁",
        "skillProperty": [
            "法术技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_a647a59e-485e-4e89-a16d-1fd08a879c6c_2117",
        "skillDescribe": {
            "main": "将光元素之力融入剑矛，跃起至指定位置并将剑矛插入地面引发冲击波，<font color='#66CD00'>眩晕</font>范围内敌方并造成伤害",
            "static": [
                "瞬间移动到目标面前，发动攻击造成法术伤害"
            ],
            "addition": [
                {
                    "initiative": "释放后获得一层<font color='#66CD00'>羽辉</font>状态",
                    "passivity": "羽辉：提升移动速度"
                }
            ],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能伤害提高25%"
                            },
                            {
                                "layer": 4,
                                "value": "技能伤害提高50%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能的最远射程提高1米"
                            },
                            {
                                "layer": 9,
                                "value": "本技能的最远射程提高3米"
                            },
                            {
                                "layer": 10,
                                "value": "本技能的最远射程提高5米"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能对敌人额外造成“破魔”效果，法术防御力降低4%，持续3秒"
                            },
                            {
                                "layer": 14,
                                "value": "本技能对敌人额外造成“破魔”效果，法术防御力降低8%，持续3秒"
                            },
                            {
                                "layer": 15,
                                "value": "本技能对敌人额外造成“破魔”效果，法术防御力降低12%，持续3秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能造成的伤害能够无视敌方10%的法术防御"
                            },
                            {
                                "layer": 14,
                                "value": "本技能造成的伤害能够无视敌方20%的法术防御"
                            },
                            {
                                "layer": 15,
                                "value": "本技能造成的伤害能够无视敌方30%的法术防御"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 6,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            },
                            {
                                "layer": 10,
                                "value": "技能冷却时间降低20%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能造成的“眩晕”效果持续时间增加0.5秒"
                            },
                            {
                                "layer": 4,
                                "value": "本技能造成的“眩晕”效果持续时间增加1秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能释放后，自身获得“霸体”状态，持续1秒"
                            },
                            {
                                "layer": 9,
                                "value": "本技能释放后，自身获得“霸体”状态，持续2秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 3,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能释放后，自身获得10%伤害减免，持续3秒"
                            },
                            {
                                "layer": 14,
                                "value": "本技能释放后，自身获得20%伤害减免，持续3秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 2,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能的控制等级额外提升5级"
                            },
                            {
                                "layer": 14,
                                "value": "本技能的控制等级额外提升10级"
                            },
                            {
                                "layer": 15,
                                "value": "本技能的控制等级额外提升15级"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ]
            ]
        }
    },
    {
        "skillName": "旋枪",
        "skillProperty": [
            "法术技能",
            "引导技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_652f0272-cb56-4030-8feb-dc2b82bee0d5_2118",
        "skillDescribe": {
            "main": "挥舞剑矛对周围敌人造成伤害和击倒效果",
            "static": [
                "每次结算造成击倒效果"
            ],
            "addition": [
                {
                    "initiative": "使自身进入风旋刃状态"
                }
            ],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能伤害提高9%%"
                            },
                            {
                                "layer": 4,
                                "value": "技能伤害提高18%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能释放后，有30%概率获得一层“羽辉”状态"
                            },
                            {
                                "layer": 9,
                                "value": "本技能释放后，有70%概率获得一层“羽辉”状态"
                            },
                            {
                                "layer": 10,
                                "value": "本技能释放后，有100%概率获得一层“羽辉”状态"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能命中敌方时产生的击倒状态持续时间提高0.5秒"
                            },
                            {
                                "layer": 14,
                                "value": "本技能命中敌方时产生的击倒状态持续时间提高1秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成伤害额外提高14%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成伤害额外提高28%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "释放过程中，可以反弹来自角色和英灵的负面技能效果和50%伤害，但冷却时间提高5秒"
                            },
                            {},
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            },
                            {
                                "layer": 10,
                                "value": "技能冷却时间降低20%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能释放后，立即获得6点左系无双值"
                            },
                            {
                                "layer": 4,
                                "value": "本技能释放后，立即获得12点左系无双值"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能释放过程中，自身伤害减免提高10%"
                            },
                            {
                                "layer": 9,
                                "value": "本技能释放过程中，自身伤害减免提高20%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能可在被控状态下使用，但冷却时间提高5秒"
                            },
                            {},
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能释放后，获得回血状态，每2秒回复自身最大生命值的2%，持续6秒"
                            },
                            {
                                "layer": 9,
                                "value": "本技能释放后，获得回血状态，每2秒回复自身最大生命值的4%，持续6秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "裂穹决",
        "skillProperty": [
            "法术技能",
            "引导技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_b10b3edb-db04-4b13-a3eb-18b671443170_2119",
        "skillDescribe": {
            "main": "划出三道剑光，对敌人造成大量伤害",
            "static": [
                "每道剑光会对被命中的敌方造成的法术伤害"
            ],
            "addition": [
                {
                    "initiative": "释放后获得一层羽辉状态"
                }
            ],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能伤害提高9%"
                            },
                            {
                                "layer": 4,
                                "value": "技能伤害提高18%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能造成的法术伤害可忽视敌人8%的法术防御力"
                            },
                            {
                                "layer": 9,
                                "value": "本技能造成的法术伤害可忽视敌人16%的法术防御力"
                            },
                            {
                                "layer": 10,
                                "value": "本技能造成的法术伤害可忽视敌人25%的法术防御力"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "当敌人的生命值高于上限50%时,本技能造成的法术伤害额外提高20%"
                            },
                            {
                                "layer": 14,
                                "value": "当敌人的生命值高于上限50%时,本技能造成的法术伤害额外提高30%"
                            },
                            {
                                "layer": 15,
                                "value": "当敌人的生命值高于上限50%时,本技能造成的法术伤害额外提高40%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成伤害额外提高14%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成伤害额外提高28%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能对眩晕状态敌人造成伤害提高17%"
                            },
                            {
                                "layer": 9,
                                "value": "本技能对眩晕状态敌人造成伤害提高34%"
                            },
                            {
                                "layer": 10,
                                "value": "本技能对眩晕状态敌人造成伤害提高51%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "裂穹斩的最中心剑光对怪物造成伤害提高30%"
                            },
                            {
                                "layer": 14,
                                "value": "裂穹斩的最中心剑光对怪物造成伤害提高60%"
                            },
                            {
                                "layer": 15,
                                "value": "裂穹斩的最中心剑光对怪物造成伤害提高100%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            },
                            {
                                "layer": 10,
                                "value": "技能冷却时间降低20%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能的吟唱时间缩短0.5秒"
                            },
                            {},
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "每道剑光会为目标施加“弱疗”状态，受治疗加强率降低6%，持续3秒，最多可叠加3层"
                            },
                            {
                                "layer": 4,
                                "value": "每道剑光会为目标施加“弱疗”状态，受治疗加强率降低12%，持续3秒，最多可叠加3层"
                            },
                            {
                                "layer": 5,
                                "value": "每道剑光会为目标施加“弱疗”状态，受治疗加强率降低20%，持续3秒，最多可叠加3层"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "每道剑光有20%概率使敌人眩晕，持续2秒"
                            },
                            {
                                "layer": 9,
                                "value": "每道剑光有30%概率使敌人眩晕，持续2秒"
                            },
                            {
                                "layer": 10,
                                "value": "每道剑光有40%概率使敌人眩晕，持续2秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 1,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "每道剑光会为目标施加“破魔”状态，法术防御力降低2%，持续3秒，最多可叠加3层"
                            },
                            {
                                "layer": 14,
                                "value": "每道剑光会为目标施加“破魔”状态，法术防御力降低4%，持续3秒，最多可叠加3层"
                            },
                            {
                                "layer": 15,
                                "value": "每道剑光会为目标施加“破魔”状态，法术防御力降低6%，持续3秒，最多可叠加3层"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "华绽天羽",
        "skillProperty": [
            "辅助技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_d1319633-72a4-4b37-ae47-330f534ec2c8_2121",
        "skillDescribe": {
            "main": "誓羽将翼环化为双翼，升空并开始飞行",
            "static": [
                "升空12米，并进入华绽天羽状态"
            ],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "华绽天羽状态下暴击率提高3%"
                            },
                            {
                                "layer": 4,
                                "value": "华绽天羽状态下暴击率提高6%"
                            },
                            {
                                "layer": 5,
                                "value": "华绽天羽状态下暴击率提高10%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "华绽天羽状态下法术破防率提高3%"
                            },
                            {
                                "layer": 9,
                                "value": "华绽天羽状态下法术破防率提高6%"
                            },
                            {
                                "layer": 10,
                                "value": "华绽天羽状态下法术破防率提高10%"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 3,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "华绽天羽状态下，获得基础最大法术攻击6%的基础最小法术攻击"
                            },
                            {
                                "layer": 14,
                                "value": "华绽天羽状态下，获得基础最大法术攻击12%的基础最小法术攻击"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 6,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "华绽天羽状态下，自身对怪物造成的伤害提高20%"
                            },
                            {
                                "layer": 9,
                                "value": "华绽天羽状态下，自身对怪物造成的伤害提高40%"
                            },
                            {
                                "layer": 10,
                                "value": "华绽天羽状态下，自身对怪物造成的伤害提高60%"
                            }
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 3,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {},
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "华绽天羽状态下非锁定技能伤害减免额外提高6%"
                            },
                            {
                                "layer": 4,
                                "value": "华绽天羽状态下非锁定技能伤害减免额外提高12%"
                            },
                            {
                                "layer": 5,
                                "value": "华绽天羽状态下非锁定技能伤害减免额外提高20%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "华绽天羽状态持续期间若受到伤害超过自身总血量的30%，则5秒内伤害减免提高4%"
                            },
                            {
                                "layer": 9,
                                "value": "华绽天羽状态持续期间若受到伤害超过自身总血量的30%，则5秒内伤害减免提高8%"
                            },
                            {
                                "layer": 10,
                                "value": "华绽天羽状态持续期间若受到伤害超过自身总血量的30%，则5秒内伤害减免提高12%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "华绽天羽状态下每两秒回复右系无双值4点"
                            },
                            {
                                "layer": 14,
                                "value": "华绽天羽状态下每两秒回复右系无双值8点"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "光影瞬袭的最远射程提高1米"
                            },
                            {
                                "layer": 9,
                                "value": "光影瞬袭的最远射程提高3米"
                            },
                            {
                                "layer": 10,
                                "value": "光影瞬袭的最远射程提高5米"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "释放光影瞬袭后，获得1秒霸体状态"
                            },
                            {
                                "layer": 14,
                                "value": "释放光影瞬袭后，获得2秒霸体状态"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ]
            ]
        }
    },
    {
        "skillName": "同光凭神",
        "skillProperty": [
            "辅助技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_bfee8210-8b68-4f93-9d4f-0a255f009dbf_2124",
        "skillDescribe": {
            "main": "自身被圣光之力笼罩，进入同光凭神状态",
            "static": [
                "解除控制，清除自身大量仇恨值并进入同光凭神状态，状态持续期间不会受到任何伤害和控制，同时无法释放无双技能"
            ],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {},
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "同光凭神状态解除后，获得1秒霸体"
                            },
                            {
                                "layer": 9,
                                "value": "同光凭神状态解除后，获得2秒霸体"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 3,
                            "totolNum": 3,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "同光凭神状态持续时间提高1秒"
                            },
                            {
                                "layer": 14,
                                "value": "同光凭神状态持续时间提高2秒"
                            }
                        ],
                        "require": {
                            "preNum": 2,
                            "totolNum": 5,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "同光凭神状态下，自身移动速度提高15%"
                            },
                            {
                                "layer": 4,
                                "value": "同光凭神状态下，自身移动速度提高30%"
                            },
                            {
                                "layer": 5,
                                "value": "同光凭神状态下，自身移动速度提高50%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            },
                            {
                                "layer": 10,
                                "value": "技能冷却时间降低20%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能释放后，对自身周围10米范围敌方附加弱疗效果，受治疗加强率降低10%，持续5秒"
                            },
                            {
                                "layer": 4,
                                "value": "本技能释放后，对自身周围10米范围敌方附加弱疗效果，受治疗加强率降低20%，持续5秒"
                            },
                            {
                                "layer": 5,
                                "value": "本技能释放后，对自身周围10米范围敌方附加弱疗效果，受治疗加强率降低30%，持续5秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "同光凭神状态持续期间，自身每2秒回复4点左系无双值"
                            },
                            {
                                "layer": 9,
                                "value": "同光凭神状态持续期间，自身每2秒回复8点左系无双值"
                            },
                            {
                                "layer": 10,
                                "value": "同光凭神状态持续期间，自身每2秒回复12点左系无双值"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "同光凭神状态解除时，自身周围10米敌人获得“盲目”，技能射程降低50%，持续5秒"
                            },
                            {
                                "layer": 14,
                                "value": "同光凭神状态解除时，自身周围15米敌人获得“盲目”，技能射程降低50%，持续5秒"
                            },
                            {
                                "layer": 15,
                                "value": "同光凭神状态解除时，自身周围20米敌人获得“盲目”，技能射程降低50%，持续5秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "镇光囚笼",
        "skillProperty": [
            "法术技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_b66a048e-4944-4b71-a1f9-86037ed3b73c_2125",
        "skillDescribe": {
            "main": "掷出一柄光矛，造成伤害并使被命中的敌人无法离开光矛形成的光元素区域",
            "static": [
                "造成法术伤害，对怪物额外造成50%伤害"
            ],
            "addition": [
                {
                    "initiative": "使敌方玩家获得囚光状态"
                }
            ],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能伤害提高9%"
                            },
                            {
                                "layer": 4,
                                "value": "技能伤害提高18%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "镇光囚笼范围内敌方法术防御力降低5%"
                            },
                            {
                                "layer": 9,
                                "value": "镇光囚笼范围内敌方法术防御力降低10%"
                            },
                            {
                                "layer": 10,
                                "value": "镇光囚笼范围内敌方法术防御力降低15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "镇光囚笼的持续时间延长0.5秒"
                            },
                            {
                                "layer": 14,
                                "value": "镇光囚笼的持续时间延长1秒"
                            },
                            {
                                "layer": 15,
                                "value": "镇光囚笼的持续时间延长1.5秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成伤害额外提高14%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成伤害额外提高28%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "镇光囚笼不再产生控制效果，造成的法术伤害额外提高30%"
                            },
                            {
                                "layer": 9,
                                "value": "镇光囚笼不再产生控制效果，造成的法术伤害额外提高50%"
                            },
                            {
                                "layer": 10,
                                "value": "镇光囚笼不再产生控制效果，造成的法术伤害额外提高80%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            },
                            {
                                "layer": 10,
                                "value": "技能冷却时间降低20%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "镇光囚笼范围内的敌方每1秒减少0.5点左右系无双值"
                            },
                            {
                                "layer": 4,
                                "value": "镇光囚笼范围内的敌方每1秒减少1点左右系无双值"
                            },
                            {
                                "layer": 5,
                                "value": "镇光囚笼范围内的敌方每1秒减少1.5点左右系无双值"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "镇光囚笼范围内的敌方受到“虚弱”效果，无双增长速度降低15%（同类效果无法共存）"
                            },
                            {
                                "layer": 9,
                                "value": "镇光囚笼范围内的敌方受到“虚弱”效果，无双增长速度降低30%（同类效果无法共存）"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "镇光囚笼范围内的敌方受到弱疗效果，受治疗加强率降低15%"
                            },
                            {
                                "layer": 14,
                                "value": "镇光囚笼范围内的敌方受到弱疗效果，受治疗加强率降低30%"
                            },
                            {
                                "layer": 15,
                                "value": "镇光囚笼范围内的敌方受到弱疗效果，受治疗加强率降低45%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "镇光囚笼范围内的敌方反控等级降低10点"
                            },
                            {
                                "layer": 9,
                                "value": "镇光囚笼范围内的敌方反控等级降低20点"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "镇光囚笼范围内的敌方造成伤害降低4%"
                            },
                            {
                                "layer": 14,
                                "value": "镇光囚笼范围内的敌方造成伤害降低9%"
                            },
                            {
                                "layer": 15,
                                "value": "镇光囚笼范围内的敌方造成伤害降低15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ]
            ]
        }
    },
    {
        "skillName": "澄空掠影",
        "skillProperty": [
            "位移技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_38fbeb2e-62c7-482d-9285-b477d1e4d34a_2127",
        "skillDescribe": {
            "main": "解除控制，并向前方位移一段距离",
            "static": [
                "接触控制，向前方瞬移15米"
            ],
            "addition": [],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能释放后，3秒内自身受到的物理伤害降低8%"
                            },
                            {
                                "layer": 4,
                                "value": "技能释放后，3秒内自身受到的物理伤害降低15%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能释放后，3秒内自身获得“羽护”，可吸收3%生命上限的伤害"
                            },
                            {
                                "layer": 9,
                                "value": "技能释放后，3秒内自身获得“羽护”，可吸收6%生命上限的伤害"
                            },
                            {
                                "layer": 10,
                                "value": "技能释放后，3秒内自身获得“羽护”，可吸收9%生命上限的伤害"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "技能释放后，立刻增加5点右系无双值"
                            },
                            {
                                "layer": 14,
                                "value": "技能释放后，立刻增加10点右系无双值"
                            },
                            {
                                "layer": 15,
                                "value": "技能释放后，立刻增加15点右系无双值"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            },
                            {
                                "layer": 10,
                                "value": "技能冷却时间降低20%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能不再对自身产生位移效果"
                            },
                            {},
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能释放后，3秒内移动速度提高20%"
                            },
                            {
                                "layer": 4,
                                "value": "技能释放后，3秒内移动速度提高50%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能移动距离提高5米(影响移动距离的效果只能生效一种)"
                            },
                            {
                                "layer": 9,
                                "value": "本技能移动距离提高10米(影响移动距离的效果只能生效一种)"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "技能释放后,自身获得“惊鸿掠影”效果,持续霸体且无法被锁定,持续1秒"
                            },
                            {},
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {},
                    {},
                    {}
                ]
            ]
        }
    },
    {
        "skillName": "翎羽绝阵",
        "skillProperty": [
            "法术技能",
            "瞬发技能"
        ],
        "skillImage": "https://nos.netease.com/tianyuapp/tianyuapp_ab70bb75-1634-4178-8931-3832eb70e92c_2129",
        "skillDescribe": {
            "main": "降下羽雨对指定区域造成持续伤害",
            "static": [
                "每秒对范围内敌方造成法术伤害"
            ],
            "addition": [
                {
                    "initiative": ""
                }
            ],
            "trainingName": [
                "凛",
                "悟",
                "羽"
            ],
            "training": [
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能伤害提高9%"
                            },
                            {
                                "layer": 4,
                                "value": "技能伤害提高18%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能对“羽落”状态下的目标额外造成2%*“羽落”层数的伤害"
                            },
                            {
                                "layer": 9,
                                "value": "本技能对“羽落”状态下的目标额外造成4%*“羽落”层数的伤害"
                            },
                            {
                                "layer": 10,
                                "value": "本技能对“羽落”状态下的目标额外造成6%*“羽落”层数的伤害"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "翎羽绝阵的结算间隔变为0.5秒一次，持续时间降低50%（习得后高级翎羽绝阵卷一·羽失效）"
                            },
                            {},
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "本技能对怪物造成伤害额外提高14%"
                            },
                            {
                                "layer": 4,
                                "value": "本技能对怪物造成伤害额外提高28%"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {},
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "技能获得无双值提高10%"
                            },
                            {
                                "layer": 4,
                                "value": "技能获得无双值提高20%"
                            },
                            {
                                "layer": 5,
                                "value": "技能获得无双值提高30%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "技能冷却时间降低7%"
                            },
                            {
                                "layer": 9,
                                "value": "技能冷却时间降低14%"
                            },
                            {
                                "layer": 10,
                                "value": "技能冷却时间降低20%"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {}
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "翎羽绝阵每次结算会扣除敌方2点轻功值"
                            },
                            {
                                "layer": 4,
                                "value": "翎羽绝阵每次结算会扣除敌方4点轻功值"
                            },
                            {
                                "layer": 5,
                                "value": "翎羽绝阵每次结算会扣除敌方6点轻功值"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "本技能每次结算有30%概率使敌人进入“羽落”状态"
                            },
                            {
                                "layer": 9,
                                "value": "本技能每次结算有60%概率使敌人进入“羽落”状态"
                            },
                            {
                                "layer": 10,
                                "value": "本技能每次结算有100%概率使敌人进入“羽落”状态"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "翎羽绝阵的持续时间增加1秒"
                            },
                            {
                                "layer": 14,
                                "value": "翎羽绝阵的持续时间增加2秒"
                            },
                            {
                                "layer": 15,
                                "value": "翎羽绝阵的持续时间增加3秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ],
                [
                    {
                        "effect": [
                            {
                                "layer": 3,
                                "value": "翎羽绝阵每次结算会扣除敌方1点左右系无双值"
                            },
                            {
                                "layer": 4,
                                "value": "翎羽绝阵每次结算会扣除敌方2点左右系无双值"
                            },
                            {
                                "layer": 5,
                                "value": "翎羽绝阵每次结算会扣除敌方3点左右系无双值"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 0,
                            "line": "49"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 8,
                                "value": "翎羽绝阵每次结算有30%概率使敌人进入“减速”状态，移动速度降低50%，持续2秒"
                            },
                            {
                                "layer": 9,
                                "value": "翎羽绝阵每次结算有60%概率使敌人进入“减速”状态，移动速度降低50%，持续2秒"
                            },
                            {
                                "layer": 10,
                                "value": "翎羽绝阵每次结算有100%概率使敌人进入“减速”状态，移动速度降低50%，持续2秒"
                            }
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 2,
                            "line": "59"
                        }
                    },
                    {
                        "effect": [
                            {
                                "layer": 13,
                                "value": "本技能每次结算有25%概率随机封印敌方1个技能，持续5秒"
                            },
                            {
                                "layer": 14,
                                "value": "本技能每次结算有50%概率随机封印敌方1个技能，持续5秒"
                            },
                            {}
                        ],
                        "require": {
                            "preNum": 0,
                            "totolNum": 4,
                            "line": "69"
                        }
                    }
                ]
            ]
        }
    }
]
for(var i = 0; i< shiyu.length; i++) {
    console.log(shiyu[i].skillName)
}
module.exports=shiyu;


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/skill-shiyu.js
// module id = 6
// module chunks = 0 1 3 4